export function leadZero (int) {
  return (int >= 0 && int < 10) ? (`0${int}`) : int
}
